import { type ResetPasswordDto } from '../dto/reset-password-payload.dto';

import { type ResetPassword } from '../models/reset-password';

export function resetPasswordToDto(payload: ResetPassword): ResetPasswordDto {
  return {
    code: payload.code,
    password: payload.password,
    password_confirmation: payload.passwordConfirmation,
  };
}
